import * as REDUX_TYPES from '../types'
/* I don't know what VIDEO_ONLY was meant to doas as it is currently never
set */
export const PLAYER_MODES =
{
  NONE: 0, POST: 1, LIST: 2, GRID: 3, SWIPE: 4,
  VIDEO_ONLY: 5
}

export const ONE_DAY_MS = 24 * 60 * 60 * 1000
export const PLAYER_STATES = {
  INIT: 0,
  STUDIO: 1,
  SONG: 2,
  MESSAGE: 3,
  EMPTY_STUDIO: 4
}
export const SONG_BLOCK = {
  NONE: 0,
  COMMENT: 1,
  CREATE: 2,
  DESCRIPTION: 3,
  LYRICS: 4,
  SIGN_IN: 5,
  PRICING: 6,
  REACTOR: 7,
  RESET: 8
}
export const CATEGORY_MODES = {
  RESET: { type: -1, categories: [] },
  ALL_MEDIA: { type: 0, categories: ['Music', 'Video'] },
  MUSIC: { type: 1, categories: ['Music'] },
  VIDEO: { type: 2, categories: ['Video'] },
  SUPPORT: { type: 3, categories: ['Support'] },
  ALL: { type: 4, categories: ['Music', 'Video', 'Support'] },
}

/**
 * 
 * @param {*} lastWarningDate A Date instance
 * @returns True if the lastWarningData is undefined or more than ONE_DAY_MS in the past
 */
export const needPreviewWarning = (lastWarningDate) => {
  //console.log(`needPreviewWarning lastWarningData ${lastWarningDate} Date.now ${Date.now()}`)
  return !lastWarningDate || (Date.now() - lastWarningDate > ONE_DAY_MS)
}

const INITIAL_STATE = {

  collections: [],
  currentCollection: undefined,
  engaged: false,
  forceSignIn: false,
  fullscreen: false,
  lastDuration: 0,
  lastPlayListIndex: undefined,
  lastPreviewWarning: undefined,
  likedPlayListIndex: null,
  playCurrentSong: false,

  playListIndex: 0,
  playerMode: PLAYER_MODES.SWIPE,
  playerState: PLAYER_STATES.INIT,
  playTime: 0,
  postBuyCreditsPage: undefined, //The page to which we transfer after BuyCredits
  postSignInPage: null, //The page to which we transfer after SignIn

  showAi: false,
  showAttachments: false,
  showChat: false,
  showCollections: false,
  songBlock: SONG_BLOCK.NONE,
  sound: false
}

const harmonizeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case REDUX_TYPES.HARMONIZE.LIKED_PLAYLIST_INDEX:
      return {
        ...state,
        likedPlayListIndex: action.likedPlayListIndex,
      }
    case REDUX_TYPES.HARMONIZE.POST_BUY_CREDITS_PAGE:
      return {
        ...state,
        postBuyCreditsPage: action.postBuyCreditsPage,
      }
    case REDUX_TYPES.HARMONIZE.POST_SIGN_IN_PAGE:
      return {
        ...state,
        postSignInPage: action.postSignInPage,
      }

    case REDUX_TYPES.HARMONIZE.SET_COLLECTIONS:
      return {
        ...state,
        collections: action.collections,
      }

    case REDUX_TYPES.HARMONIZE.SET_CURRENT_COLLECTION:
      return {
        ...state,
        currentCollection: action.currentCollection,
      }
    case REDUX_TYPES.HARMONIZE.SET_ENGAGED:
      return {
        ...state,
        engaged: action.engaged,
      }
    case REDUX_TYPES.HARMONIZE.SET_FORCE_SIGN_IN:
      return {
        ...state,
        forceSignIn: action.forceSignIn,
      }
    case REDUX_TYPES.HARMONIZE.SET_FULLSCREEN:
      return {
        ...state,
        fullscreen: action.fullscreen,
      }

    case REDUX_TYPES.HARMONIZE.SET_LAST_PREVIEW_WARNING:
      return {
        ...state,
        lastPreviewWarning: action.lastPreviewWarning,
      }
    case REDUX_TYPES.HARMONIZE.PLAY_CURRENT_SONG:
      return {
        ...state,
        playCurrentSong: action.playCurrentSong,
      }

    case REDUX_TYPES.HARMONIZE.SET_PLAYLIST_INDEX:
      return {
        ...state,
        playListIndex: action.playListIndex,
      }
    case REDUX_TYPES.HARMONIZE.SET_PLAYER_MODE:
      return {
        ...state,
        playerMode: action.playerMode,
      }
    case REDUX_TYPES.HARMONIZE.SET_PLAYER_STATE:
      return {
        ...state,
        playerState: action.playerState,
      }
    case REDUX_TYPES.HARMONIZE.SET_PLAY_TIME:
      return {
        ...state,
        playTime: action.playTime,
      }

    case REDUX_TYPES.HARMONIZE.SET_SHOW_AI:
      return {
        ...state,
        showAi: action.showAi,
      }
    case REDUX_TYPES.HARMONIZE.SET_SHOW_ATTACHMENTS:
      return {
        ...state,
        showAttachments: action.showAttachments,
      }
    case REDUX_TYPES.HARMONIZE.SET_SHOW_CHAT:
      return {
        ...state,
        showChat: action.showChat,
      }
    case REDUX_TYPES.HARMONIZE.SET_SHOW_COLLECTIONS:
      return {
        ...state,
        showCollections: action.showCollections,
      }
    case REDUX_TYPES.HARMONIZE.SONG_BLOCK:
      return {
        ...state,
        songBlock: action.songBlock,
      }
    case REDUX_TYPES.HARMONIZE.SOUND:
      return {
        ...state,
        sound: action.sound,
      }
    case REDUX_TYPES.HARMONIZE.RESET:
      return INITIAL_STATE
    default:
      return state
  }
}
export default harmonizeReducer
